import ResponsiveColumn from './ResponsiveColumn.styles';

export default ResponsiveColumn;
